module.exports = __webpack_public_path__ + "img/185.5c2435fe.jpg";